/**
 * Arabic translations for admin panel.
 */

const admin = {
  fal: {
    status: 'حالة الفال',
    pending: 'قيد المراجعة',
    approved: 'معتمد',
    rejected: 'مرفوض',
    approve: 'اعتماد الفال',
    reject: 'رفض الفال',
    revoke: 'إلغاء اعتماد الفال',
    rejectTitle: 'رفض ترخيص الفال',
    rejectReason: 'سبب الرفض',
    rejectReasonPlaceholder: 'اشرح سبب رفض ترخيص الفال...',
    confirmReject: 'تأكيد الرفض',
    licenseNumber: 'رقم ترخيص الفال',
    noLicense: 'لم يتم تقديم ترخيص',
    approved_toast: 'تم اعتماد ترخيص الفال بنجاح',
    rejected_toast: 'تم رفض ترخيص الفال',
    revoked_toast: 'تم إلغاء اعتماد الفال (تعيين كقيد المراجعة)',
  },

  // إعداد المصادقة الثنائية لحسابات المسؤولين (pages/admin/setup-2fa/page.tsx).
  // المصطلحات من common.auth: «المصادقة الثنائية»، «تطبيق المصادقة»، «رموز النسخ الاحتياطي».
  twoFa: {
    title: 'إعداد المصادقة الثنائية',
    subtitle: 'مطلوبة لحسابات المسؤولين',
    loading: 'جارٍ التحميل…',
    steps: {
      label: 'خطوات إعداد المصادقة الثنائية',
      scan: 'مسح الرمز',
      verify: 'تأكيد الرمز',
      backup: 'رموز النسخ الاحتياطي',
    },
    scanIntro: 'امسح رمز QR هذا بتطبيق المصادقة (Google Authenticator أو Authy أو 1Password):',
    qrAlt: 'رمز QR لإعداد المصادقة الثنائية',
    manualHint: 'لا يمكنك المسح؟ أدخل هذا الرمز يدوياً:',
    added: 'أضفته، انتقل إلى التأكيد',
    verifyIntro: 'أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة:',
    codeLabel: 'رمز التحقق',
    verify: 'تحقّق',
    verifying: 'جارٍ التحقق…',
    back: 'رجوع',
    confirmFailed: 'تعذّر التأكيد. حاول مرة أخرى.',
    backupTitle: 'احفظ رموز النسخ الاحتياطي الآن.',
    backupBody: 'تظهر مرة واحدة فقط، وكل رمز يُستخدم مرة واحدة بدلاً من تطبيق المصادقة.',
    acknowledge: 'حفظت هذه الرموز في مكان آمن',
    finish: 'إنهاء',
  },
};

export default admin;
